import {html} from 'lit-html';

const template = (data, filter) => html`
<div class="item-filter-input-container">
	<label class="item-fitler-input-label">${filter.label}</label>
	<div class="item-fitler-input-type-select-container">
		<select class="item-filter-input-type-select" name="${filter.name}" @change=${filter}>
			<option value="">-</option>
			${filter.options.map(option => html`
			<option value="${option.value}" ?selected=${filter.getValue() == option.value}>${option.text}</option>
			`)}
		</select>
	</div>
</div>
`;

export default template;